import actions from './actions.ts'

const initialState = {
  id: '',
  name: '',
  role: '',
  email: '',
  avatar: '',
  authorized: process.env.REACT_APP_AUTHENTICATED || false, // false is default value
  loading: false,
  umkProcessing: false,
  safebox: null,
  workspace: null,
  provisioning: false,
  resetPW: false,
  recoveryUMK: false,
  error_shown: true,
  verificationEmail: '',
  workspaceList: [],
  noLogin: false,
  leakedCount: null,
  // 가입 상태 — INNER_LOAD_CURRENT_ACCOUNT saga가 currentAccount() 응답에서 dispatch.
  // 'login' | 'register' | 'change-password' | 'expired' | 'ip-blocked' 등.
  authType: '',
  // JWT provider claim — 'saml' | 'basic' | 'officenext' 등.
  // SAML 사용자 식별용 (PR #1051 후속 hotfix). authType은 가입 상태이므로 SAML 여부 판단 불가.
  provider: '',
  // Phase 3a PR 2-2 (#1117): saga → 글로벌 PasskeyAutoFlow 컴포넌트 trigger.
  // 'register' | null. (DBE Keeper #1291 v1.5: 'recalc'/'recalc-from-839' 폐기 — 설계 §1.2.1)
  passkeyAutoFlow: null,
  // PR2 (recovery_option): persisted 복구정책(per-ws) — INNER_LOAD_CURRENT_ACCOUNT가 /me에서 read.
  // transient settings.recoveryOption(가입 시 선택값)과 별개. Settings 드롭다운 현재값/게이팅용.
  recovery_option: '',
  // 워크스페이스 복구키(WRKP) 초기화 여부 — /me 응답값. Settings 복구키 위치 드롭다운의
  // Server 옵션 노출 게이팅용 (INNER_LOAD_CURRENT_ACCOUNT가 read).
  wrkp_initialized: false,
  // 재설정 OTP 자가 발송 허용 여부(KR: LOCAL + 유일 활성 관리자) — LoginMasterPW 재설정 클릭 시
  // 상태 API 값으로 매번 덮어쓰고, verifyMasterPW 가 읽는다. null = 아직 조회 안 함(새로고침·직접 진입
  // 시 화면이 상태 API 로 복원). LOGOUT 에서 null 로 리셋 (설계 sole_admin_self_reset_otp D6).
  can_request_reset_otp: null,
  // PR-F: KR 라이선스/계약 종료 코드(890 계약만료 / 891 라이선스 비활성) — restClient가 사용중
  // 감지 시 세팅, layouts가 관찰해 안내+로그아웃. LOGOUT 리셋서 null(재로그인 재감지용).
  licenseTerminated: null,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }

    default:
      return state
  }
}
